import React from 'react';
import { SelectInput, TextInput, Button, Container, Row, Col } from '@digitools/honest-react';
import { useFormState } from 'informed';
import LanguageToggle from 'src/utils/LanguageToggle';
export const SearchForm = () => {
    const formState = useFormState();
    const options = [{ label: 'Employee ID', value: 'empId' }, { label: 'Employee name', value: 'empName' }];
    const getPlaceholder = (searchCriteria) => {
        switch (searchCriteria) {
            case 'empName':
                return 'Enter last name, first name';
            case 'empId':
                return 'Enter employee ID';
            default:
                return 'Select search criteria';
        }
    };
    const validateEmployeeName = (input) => {
        if (!input || input.length < 3) {
            return <LanguageToggle en='Employee name: please enter at least three letters of the last name.' es='Nombre del empleado: ingrese al menos tres letras del apellido.'/>;
        }
    };
    const validateSelect = (input) => {
        if (!input) {
            return <LanguageToggle en='Search criteria is required' es='Los criterios de búsqueda son obligatorios'/>;
        }
    };
    const validateContent = (input) => {
        if (!input) {
            return <LanguageToggle en='Search: please enter search criteria.' es='Búsqueda: ingrese los criterios de búsqueda.'/>;
        }
    };
    const getSearchValidator = (searchCriteria) => {
        switch (searchCriteria) {
            case 'empName':
                return validateEmployeeName;
            default:
                return validateContent;
        }
    };
    const getSearchLabel = (searchCriteria) => {
        switch (searchCriteria) {
            case 'empName':
                return 'Employee name';
            case 'empId':
                return 'Employee ID';
            default:
                return 'Search';
        }
    };
    const placeholder = getPlaceholder(formState.values.searchCriteria);
    const validateSearch = getSearchValidator(formState.values.searchCriteria);
    const searchLabel = getSearchLabel(formState.values.searchCriteria);
    return (<Container>
      <Row data-public={true}>
        <Col sm={12} md={4} lg={4}>
          <SelectInput data-testid='searchCriteria' field='searchCriteria' label='Search criteria' placeholderText='Search criteria' options={options} validate={validateSelect} aria-label={'Search criteria'}/>
        </Col>
        <Col sm={12} md={5} lg={5}>
          <TextInput data-testid='search' field='search' label={searchLabel} placeholder={placeholder} type={'text'} icon={'search'} validate={validateSearch} aria-label={'search'} data-private={true}/>
        </Col>
        <Col sm={12} md={3} lg={3}>
          <Button aria-label={'search'} data-testid='submit' type='submit' buttonType='primary'>
            Search
          </Button>
        </Col>
      </Row>
    </Container>);
};
export default SearchForm;
